import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { useInView } from "@/shared/hooks/useInView"
import { Disclaimer } from "@/shared/ui/Disclaimer"
import { Reveal } from "@/shared/ui/Reveal"
import { Section } from "@/shared/ui/Section"
import { SectionHeading } from "@/shared/ui/SectionHeading"
import { Icon } from "@/shared/ui/icons"

export function HowItWorksSection() {
  const { steps } = useSiteContent()
  const { ref, inView } = useInView()

  return (
    <Section ref={ref} id="como-funciona" tone="white">
      <Reveal inView={inView} className="mb-14 lg:mb-16 max-w-lg">
        <SectionHeading eyebrow="Como funciona" title="Cuidar pode ser mais simples" />
      </Reveal>

      <div className="grid md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 lg:gap-12 relative">
        {/* Linha que conecta os tres passos no desktop. */}
        <div
          className="hidden md:block absolute top-10 left-[calc(16.67%+24px)] right-[calc(16.67%+24px)] h-[2px]"
          style={{
            background: "linear-gradient(90deg, #C9963B 0%, #D8B36A 50%, #C9963B 100%)",
            opacity: 0.25,
          }}
          aria-hidden="true"
        />

        {steps.map((step, index) => (
          <Reveal
            key={step.number}
            inView={inView}
            delayMs={index * 120}
            distance="lg"
            className="flex flex-col gap-5 relative"
          >
            {index < steps.length - 1 && (
              <div className="md:hidden absolute left-6 top-20 bottom-0 w-px bg-dourado/20" aria-hidden="true" />
            )}

            <div className="relative">
              <span
                className="absolute -top-4 -left-2 text-[80px] font-bold leading-none select-none pointer-events-none text-verde-profundo/[0.04]"
                aria-hidden="true"
              >
                {step.number}
              </span>

              <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-off-white to-[#E8E6E0] border border-verde-profundo/10 flex items-center justify-center text-verde-profundo shrink-0 z-10 shadow-sm">
                <Icon name={step.icon} />
                <span
                  className="absolute -top-2.5 -right-2.5 w-6 h-6 rounded-full bg-gradient-to-br from-dourado to-dourado-claro text-white text-[11px] font-bold flex items-center justify-center shadow-sm"
                  aria-hidden="true"
                >
                  {index + 1}
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <p className="text-[11px] font-semibold tracking-widest uppercase text-dourado-escuro/70">
                Passo {step.number}
              </p>
              <h3 className="text-xl font-semibold text-verde-profundo leading-snug">{step.title}</h3>
              <p className="text-verde-profundo/60 text-base leading-relaxed">{step.description}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Disclaimer className="mt-12 max-w-2xl">
        Coberturas, carências, limites, coparticipações e condições de contratação variam conforme o plano e o
        regulamento.
      </Disclaimer>
    </Section>
  )
}
